export interface ItemState {
  groupKey: string;
  tabKey: string;
  itemKey: string;
  state?: boolean;
}

export interface ListUpdate {
  keys: string[];
  state: TriState;
  bypassConsentCheck: boolean;
  bypassConsentDeclinePrCheck: boolean;
  skipNotification: boolean;
  sourceGroup?: string;
  sourceItem?: string;
  sourceComponent?: string;
  sourceTab?: string;
}

export enum TriState {
  false,
  true,
  busy,
}

export interface ItemUpdateState {
  groupKey: string;
  tabKey: string;
  itemKey: string;
  state: TriState;
}

export interface ItemMeta {
  groupKey: string;
  tabKey: string;
  itemKey: string;
}

export type ActionType =
  | 'updatePreferences'
  | 'unsubscribeAll'
  | 'unsubscribeKeys'
  | 'subscribeKeys'
  | 'acceptGmoi'
  | 'request';

export type ResultStatus = 'success' | 'error';

export interface ActionResult {
  key: ActionType;
  status: ResultStatus;
  data?: string[];
}

export interface SubscriptionReferralUrlParams {
  hid?: string;
  source?: string;
  unsubscribeKeys?: string;
  subscribeKeys?: string;
  jobId?: string;
}

type StatusType = 'ok' | 'not-found' | 'down-for-maintenance' | 'empty' | 'login-required';
export interface Status {
  status: StatusType;
  message?: string;
}

type VisibleAllGroup = 'all';
export type VisibleGroup = {
  groupKey: string | VisibleAllGroup;
  tabKey?: string;
};

export interface DialogPayload {
  showDialog: boolean;
  update?: ListUpdate;
}
